import { Link, useResolvedPath, useMatch } from 'react-router-dom';

export default function DashboardNavLink({
  text,
  to,
  altTo = 'invalid path',
  className,
  disabled = false,
  end = false,
}) {
  const resolved = useResolvedPath(to);
  const match = useMatch({ path: resolved.pathname, end });

  const altResolved = useResolvedPath(altTo);
  const altMatch = useMatch({ path: altResolved.pathname, end });

  const span = (
    <span
      className={`${match || altMatch ? 'font-bold text-primary' : ''} ${
        className ? className : ''
      }`}
    >
      {text}
    </span>
  );

  if (disabled) {
    return span;
  }

  return (
    <Link className="hover:text-primary" to={to}>
      {span}
    </Link>
  );
}
